import { render, staticRenderFns } from "./OrderStatusChanger.vue?vue&type=template&id=c8a55f56&scoped=true&"
import script from "./OrderStatusChanger.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChanger.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusChanger.vue?vue&type=style&index=0&id=c8a55f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a55f56",
  null
  
)

export default component.exports